import "isomorphic-fetch";
import { downloadGetAll } from './download.actions';
import { cartConstants } from '../_constants';
import { cartApi } from '../api';
import { history } from '../_helpers';
import { checkUnauthorized } from '../_helpers/handleResponse';

/*
CART_FETCH_DATA_SUCCESS
CART_ADD_ONE_SUCCESS
CART_DEL_ONE_SUCCESS
CART_CLEAR_SUCCESS
CART_SEND_SUCCESS
CART_DOWNLOAD_SUCCESS
*/

// Zentrale Error-Handler Funktion
function handleCartError(response) {
  checkUnauthorized(response, response.statusText);
  if(response.status === 403)
    history.push('/login');
  throw Error(response.statusText);
}

function cartHasErrored(bool) {
  return {
    type: cartConstants.CART_HAS_ERRORED,
    hasErrored: bool
  };
}

function cartIsLoading(bool) {
  return {
    type: cartConstants.CART_IS_LOADING,
    isLoading: bool
  };
}

function cartDownloadIsLoading(bool) {
  return {
    type: cartConstants.CART_DOWNLOAD_IS_LOADING,
    isLoading: bool
  };
}

function cartDownloadListIsLoading(bool) {
  return {
    type: cartConstants.CART_DOWNLOAD_LIST_IS_LOADING,
    isLoading: bool
  };
}

function cartFetchDataSuccess(cart) {
  return {
    type: cartConstants.CART_FETCH_DATA_SUCCESS,
    cart
  };
}

// function cartGetOneSuccess(cart) {
//   return {
//     type: cartConstants.CART_GET_ONE_SUCCESS,
//     cart
//   };
// }

function cartSendSuccess(bool) {
  return {
    type: cartConstants.CART_SEND_SUCCESS,
    cartSent: bool
  };
}

function cartDownloadListSuccess(bool) {
  return {
    type: cartConstants.CART_DOWNLOAD_LIST_SUCCESS,
    cartSent: bool
  };
}

function cartUpdateCartCheckboxes(cartCheckboxState) {
  return {
    type: cartConstants.CART_UPDATE_CHECKBOXES,
    cartCheckboxState
  }
}

function updateCheckboxes(cartItems) {
  let checkboxes = [];
  if (!cartItems) return checkboxes;
  
  for(let item of cartItems){
    // Nur die tatsächlich im Cart ausgewählten Formate ankreuzen
    if (item.downloadFormatId) {
      checkboxes[`${item.assetId}.${item.downloadFormatId}`] = true;
    }
  }
  return checkboxes;
}

// Get cart
export function cartGetCart() {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    cartApi.getCart()
    .then(response => {
      if (response.status >= 400) {
        handleCartError(response);
      }
      dispatch(cartUpdateCartCheckboxes(updateCheckboxes(response.data.items)));
      dispatch(cartIsLoading(false));
      return response;
    })
    .then(cart => dispatch(cartFetchDataSuccess(cart.data)))
    .catch((error) => {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };  
}

// Add asset to cart
export function cartAddOne(assetId, downloadFormatId = null) {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    cartApi.addToCart(assetId, downloadFormatId)
    .then(response => {
      if (response.status >= 400) {
        handleCartError(response);
      }
      dispatch(cartIsLoading(false));
      if (response.data.items) {
        dispatch(cartUpdateCartCheckboxes(updateCheckboxes(response.data.items)));
      }
      return response;
    })
    .then(cart => dispatch(cartAddOneSuccess(cart.data)))
    .catch((error) => {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };
}

// Remove asset from cart
export function cartRemoveOne(assetId, downloadFormatId = null) {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    cartApi.removeFromCart(assetId, downloadFormatId)
    .then(response => {
      if (response.status >= 400) {
        handleCartError(response);
      }
      dispatch(cartIsLoading(false));
      if (response.data.items) {
        dispatch(cartUpdateCartCheckboxes(updateCheckboxes(response.data.items)));
      }
      return response;
    })
    .then(cart => dispatch(cartDelOneSuccess(cart.data)))
    .catch((error) => {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };
}

// Clear cart
export function cartClear() {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    cartApi.clearCart()
    .then(response => {
      if (response.status >= 400) {
        handleCartError(response);
      }
      dispatch(cartIsLoading(false));
      return response;
    })
    .then(cart => dispatch(cartClearSuccess()))
    .catch((error) => {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };
}

// Send cart via email
export function cartSend(form, lang) {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    const receiver = form.receiver || form.email;
    const subject = form.subject || '';
    const message = form.message || '';
    
    cartApi.sendCart(receiver, lang, subject, message)
    .then(response => {
      if (response.status >= 400) {
        handleCartError(response);
      }
      dispatch(cartIsLoading(false));
      return response;
    })
    .then(response => dispatch(cartSendSuccess(true)))
    .catch((error) => {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };
}

export function cartSendReset() {
  return (dispatch) => {
    dispatch(cartSendSuccess(false));
  };
}

// Download cart
export function cartDownload() {
  return (dispatch) => {
    dispatch(cartDownloadIsLoading(true));
    cartApi.downloadCart()
    .then(response => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = href;
      const filename = `mediabox-cart-${new Date().toISOString().split('T')[0]}.zip`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      dispatch(cartDownloadIsLoading(false));
      dispatch(downloadGetAll());
      dispatch(cartGetCart()); // Refresh cart after download
    })
    .then(() => dispatch(cartDownloadSuccess(true)))
    .catch((error) => {
      dispatch(cartDownloadIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };  
}

// Download outgoing cart by ID
export function cartDownloadOutgoing(cartId) {
  return (dispatch) => {
    dispatch(cartDownloadIsLoading(true));
    cartApi.downloadOutgoingCart(cartId)
    .then(response => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `cart-${cartId}.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      dispatch(cartDownloadIsLoading(false));
    })
    .catch((error) => {
      dispatch(cartDownloadIsLoading(false));
      dispatch(cartHasErrored(true));
    });
  };
}

function cartAddOneSuccess(cart) {
  return {
    type: cartConstants.CART_ADD_ONE_SUCCESS,
    cart
  };
}

function cartDelOneSuccess(cart) {
  return {
    type: cartConstants.CART_DEL_ONE_SUCCESS,
    cart
  };
}

function cartClearSuccess(cart) {
  return {
    type: cartConstants.CART_CLEAR_SUCCESS,
    cart: { items: [] }
  };
}

function cartDownloadSuccess(bool) {
  return {
    type: cartConstants.CART_DOWNLOAD_SUCCESS,
    downloadSuccess: bool
  };
}

// Legacy compatibility exports (mapped to new functions)
export const cartGetOne = cartGetCart;
export const cartGetAll = cartGetCart;
export const cartAddOneFormat = cartAddOne;
export const cartRemoveOneFormat = cartRemoveOne;

// Legacy functions for multi-item operations (now handled by single API calls)
// Note: New API doesn't have bulk add/remove endpoints, so we loop through items
export function cartAddManyFormat(assetIds, format) {
  return async (dispatch) => {
    dispatch(cartIsLoading(true));
    try {
      for (const assetId of assetIds) {
        await cartApi.addToCart(assetId, format);
      }
      // Refresh cart after all additions
      const response = await cartApi.getCart();
      dispatch(cartIsLoading(false));
      if (response.data.items) {
        dispatch(cartUpdateCartCheckboxes(updateCheckboxes(response.data.items)));
      }
      dispatch(cartAddOneSuccess(response.data));
    } catch (error) {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    }
  };
}

export function cartRemoveManyFormat(assetIds, format) {
  return async (dispatch) => {
    dispatch(cartIsLoading(true));
    try {
      for (const assetId of assetIds) {
        await cartApi.removeFromCart(assetId, format);
      }
      // Refresh cart after all removals
      const response = await cartApi.getCart();
      dispatch(cartIsLoading(false));
      if (response.data.items) {
        dispatch(cartUpdateCartCheckboxes(updateCheckboxes(response.data.items)));
      }
      dispatch(cartDelOneSuccess(response.data));
    } catch (error) {
      dispatch(cartIsLoading(false));
      dispatch(cartHasErrored(true));
    }
  };
}

export function cartAddAllFormat(assetIds, format){
  return cartAddManyFormat(assetIds, format);
}

export function cartRemoveAllFormat(assetIds, format){
  return cartRemoveManyFormat(assetIds, format);
}

// Legacy function for fetching cart by ID (new API doesn't support this, uses current user's cart)
export function cartFetchData(id) {
  return cartGetCart();
}

export function cartDownloadList() {
  return (dispatch) => {
    dispatch(cartDownloadListIsLoading(true));
    cartApi.listCart()
    .then(response => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'artikeluebersicht.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      dispatch(cartDownloadListIsLoading(false));
      dispatch(cartGetCart());
    })
    .catch((error) => {
      dispatch(cartDownloadListIsLoading(false));
      dispatch(cartHasErrored(true));
    });
    dispatch(cartDownloadListSuccess(false));
  };
}
